define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var Chips = require('chips').default;

    var ContentPreviewDialogViewController = ViewController.extend({
        ControllerName: 'ContentPreviewDialogViewController',

        LPViewMap: {
            dialog: '.lpview_content_preview_dialog',
            textContentWrapper: '.lpview_text_content_wrapper',
            structuredContentWrapper: '.lpview_structured_content_wrapper',
            quickRepliesWrapper: '.lpview_quick_replies_wrapper',
            closeButton: '.lpview_close_content_preview_dialog',
            sendButton: '.lpview_content_preview_send_button',
            cancelButton: '.lpview_content_preview_cancel_button'
        },

        initialize: function () {
            this._init();
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.closeButton, DOMEvent: "click", callback: this.hideDialog});
            this.bindViewEvent({selector: this.LPViewMap.sendButton , DOMEvent: "click", callback: this.sendClicked});
            this.bindViewEvent({selector: this.LPViewMap.cancelButton , DOMEvent: "click", callback: this.cancelledClicked});
        },

        render: function () {
            var textElement = this.getFirstElement(this.LPViewMap.textContentWrapper);
            textElement.textContent = this.content && this.content.text ? this.content.text : '';

            var structuredContentElement = this.getFirstElement(this.LPViewMap.structuredContentWrapper);
            structuredContentElement.innerHTML = '';
            if (this.content  && this.content.scRenderResult) {
                structuredContentElement.appendChild(this.content.scRenderResult);
            }

            // render quick replies preview
            if (this.content && this.content.quickReplies) {
                this.chips.render({
                    items: this.content.quickReplies.replies,
                    rowSize: this.content.quickReplies.itemsPerRow
                });
                this.chips.readonly(true);
            }
            else {
                this.chips.dispose();
                this._init();
            }
        },

        _init: function () {
            this.chips = new Chips({
                el: this.getFirstElement(this.LPViewMap.quickRepliesWrapper),
                lazy: true,
                renderer: Chips.Renderer.StructuredContentButton
            });
        }
    });

    ContentPreviewDialogViewController.prototype.showDialog = function () {
        this.lpShow();
    };

    ContentPreviewDialogViewController.prototype.hideDialog = function () {
        this.lpHide();
    };

    ContentPreviewDialogViewController.prototype.setContent = function (options) {
        this.content = options;
        this.error = false;
        this.render();
    };

    ContentPreviewDialogViewController.prototype.onSend = function (callback) {
        if(_.isFunction(callback)) {
            this.sendCallback = callback;
        }
    };

    ContentPreviewDialogViewController.prototype.sendClicked = function () {
        if(_.isFunction(this.sendCallback)) {
            this.sendCallback();
        }
        this.hideDialog();
    };

    ContentPreviewDialogViewController.prototype.cancelledClicked = function () {
        this.hideDialog();
    };

    ContentPreviewDialogViewController.prototype.dispose = function() {
        this.chips.dispose();
        ViewController.prototype.dispose.call(this);
    };

    return ContentPreviewDialogViewController;
});
